import React from 'react';

import { Helmet } from 'react-helmet';
import { ContentWrapper } from 'src/components/ContentWrapper';
import { makeStyles } from 'tss-react/mui';

import { SkillsList } from './SkillsList';

const useStyles = makeStyles()({
  listContainer: { minHeight: 0, minWidth: 0 },
});

export const AgentPersonalizationPage = React.memo(
  function AgentPersonalizationPage(): JSX.Element {
    const { classes } = useStyles();
    return (
      <>
        <Helmet>
          <title>Agent Personalization</title>
        </Helmet>
        <ContentWrapper className={classes.listContainer}>
          <SkillsList />
        </ContentWrapper>
      </>
    );
  }
);
